import { style } from "@vanilla-extract/css";

/**
 * Flex slots for the version dropdowns. The user-version chip hosts up to
 * four trigger-action icons (inspect / set-main / rename / delete), so it
 * gets a wider share of the row than the read-only dropdowns.
 */
export const userVersionSlot = style({
  display: "flex",
  flex: "1.4 1 0",
  minWidth: 0
});

export const versionSlot = style({
  display: "flex",
  flex: "1 1 0",
  minWidth: 0
});
